import { useState, useEffect } from "react";

export default function useMediaQuery(maxWidth) {
  const [matches, setMatches] = useState(
    typeof window !== "undefined" ? window.innerWidth <= maxWidth : false,
  );

  useEffect(() => {
    function handleResize() {
      setMatches(window.innerWidth <= maxWidth);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [maxWidth]);

  return matches;
}
export function useBreakpoint() {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200,
  );
  useEffect(() => {
    const handle = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handle);
    return () => window.removeEventListener("resize", handle);
  }, []);
  return {
    width,
    isMobile: width < 640,
    isTablet: width >= 640 && width < 1024,
    isDesktop: width >= 1024,
  };
}

